<template>
    <div class="Header">
        <div class="logo">
            <div class="logo_img">
                <el-avatar :src="logo"/>
            </div>
            <div class="logo_name">外网提取</div>
        </div>

        <div class="info">
            <div class="avatar">
                <div style="margin-top:12px">
                    <el-avatar :size="40" :src="headImgUrl"/>
                </div>
            </div>

            <div class="username">
                <span>{{username}}</span>
            </div>
            <div class="layout">
                <span  v-if="username!=='游客'">
                    <a href="#" @click="layout()">退出登录</a>
                </span>
                <span v-if="username==='游客'">
                <a href="#" @click="login()">立刻登录</a>
                </span>
            </div>

        </div>

    </div>
</template>

<script>
    import {ElMessage} from 'element-plus';
    import logo from "../assets/img/logo.jpg";

    export default {
        name: "Header",
        data() {
            return {
                username: "游客",
                headImgUrl: "https://ziyuan.guwendao.net/authorImg300/xinqiji.jpg",
                time: '',
                logo: logo,
            }
        },
        mounted() {
            this.getUserInfo();
        },
        methods: {
            login() {
                this.$router.replace("/login");
                window.open("http://localhost:9008/#/login");
                ElMessage({
                    message: 'login',
                    type: 'success',
                });
            },
            layout() {
                window.sessionStorage.removeItem("token");
                window.sessionStorage.removeItem("userInfo");
                window.location.reload();
                ElMessage({
                    message: '退出成功',
                    type: 'success',
                });
                this.$router.replace("/pages/single/SingleList");
            },
            //在sessionStorage获取用户信息
            getUserInfo() {
                const userInfo = window.sessionStorage.getItem('userInfo');
                this.userInfo = JSON.parse(userInfo);
                if (null != this.userInfo) {
                    this.headImgUrl = this.userInfo.headImgUrl;
                    this.username = this.userInfo.username;
                    console.log("headImgUrl:" + this.headImgUrl);
                    console.log("username:" + this.username);
                }
            },

        }
    }
</script>

<style lang="less" scoped>
    a {
        text-decoration: none;
        color: deepskyblue;
    }

    .Header {
        height: 4rem;
        width: 100%;
        background-color: cornflowerblue;
        display: flex;
        justify-content: flex-end;
        line-height: 4rem;

        .logo {
            width: 70%;
            display: flex;
            justify-content: flex-start;

            .logo_img {
                margin-top: 0.6em;
            }

            .logo_name {
                margin-left: 0.5em;
                font-weight: 600;
                font-size: large;
                color: white;
            }
        }

        .info {
            width: 30%;
            display: flex;
            justify-content: end;

            .avatar {
                line-height: 4rem;
            }

            .username {
                line-height: 4rem;
                margin-left: 20px;
                text-align: center;
                font-size: 14px;
                font-weight: bolder;
                color: white;
                margin-right: 20px;
            }

            .layout {
                line-height: 60px;
                font-size: 14px;
                margin-right: 20px;
                font-weight: bolder;
                color: black;
                margin-top: 3px;

                a:hover {
                    color: orange;
                }
            }
        }


    }


</style>
